<template>
  <div id="mapContainer" class="map-box"></div>
</template>

<script>
  import AMapLoader from "@amap/amap-jsapi-loader";
  import polygonPath from "./gfz.json";

  export default {
    name: "GuofuMap",
    props: {
      points: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        map: null,
        polygonPath,
        markers: [], // 存储 marker 和 text
      };
    },
    watch: {
      points: {
        handler(newPoints) {
          this.renderPoints(newPoints);
        },
        immediate: true,
        deep: true,
      },
    },
    mounted() {
      this.initMap();
    },
    methods: {
      initMap() {
        AMapLoader.load({
          key: "4a55e427d315bb3286f2f0b2bc333be2", // 替换为你自己的高德Key
          version: "2.0",
          plugins: [],
        })
          .then((AMap) => {
            this.map = new AMap.Map("mapContainer", {
              resizeEnable: true,
              zoom: 15,
              center: [106.56926959456759, 28.84572992941223],
              mapStyle: "amap://styles/grey",
            });

            // 添加郭扶镇边界
            const polygon = new AMap.Polygon({
              path: this.polygonPath.features[0].geometry.coordinates[0],
              strokeColor: "rgb(28,184,249)",
              strokeWeight: 3,
              fillColor: "rgb(31,89,142)",
              fillOpacity: 0.5,
            });
            this.map.add(polygon);

            // 设置限制边界和缩放视野
            const bounds = polygon.getBounds();
            this.map.setLimitBounds(bounds);
            this.map.setFitView([polygon]);

            // 设置遮罩（全国遮罩留郭扶区域）
            const fullBounds = [
              [73.0, 18.0],
              [135.0, 18.0],
              [135.0, 54.0],
              [73.0, 54.0],
            ];
            const guofuPath = this.polygonPath.features[0].geometry.coordinates[0];
            const maskPolygon = new AMap.Polygon({
              path: [fullBounds, guofuPath],
              strokeColor: null,
              fillColor: "rgba(8,34,91,0.9)",
              fillOpacity: 0.8,
              strokeWeight: 0,
              bubble: true,
              zIndex: 1000,
            });
            this.map.add(maskPolygon);

            // 渲染传入的标点
            this.renderPoints(this.points);
          })
          .catch((e) => {
            console.error("高德地图加载失败：", e);
          });
      },

      renderPoints(points) {
        if (!this.map) return;

        // 清除已有标记
        this.markers.forEach((m) => {
          this.map.remove(m);
        });
        this.markers = [];

        // 添加新标点及文字
        points.forEach((point) => {
          const marker = new AMap.Marker({
            position: point.position,
            title: point.name,
          });
          this.map.add(marker);
          this.markers.push(marker);

          // 添加文字标注
          const text = new AMap.Text({
            text: point.name,
            position: point.position,
            offset: new AMap.Pixel(-26, -52),
            style: {
              'background-color': 'transparent',
              'border': 'none',
              'color': '#999',
              'font-size': '13px',
              // 'font-weight': 'bold',
              'text-shadow': '0 0 2px #000',
            },
          });
          this.map.add(text);
          this.markers.push(text);

          // 添加点击事件
          marker.on("click", () => {
            // 向父组件派发点击事件
            this.$emit("handleClickMap", point);
            console.log(point)
          });
        });
      },
    },
  };
</script>

<style scoped>
  .map-box {
    width: 100%;
    height: 100%;
  }
</style>